import React from "react";
import { Form } from "antd";
import { FormProps } from "antd/lib/form";
import ConfigComponent from "../config components/config.Components";

interface FormComponentProps extends FormProps {}

const FormComponent = (props: FormComponentProps) => {
  const { form: formDef } = ConfigComponent;
  const { ...antdProps } = props;

  return <Form {...formDef as any} {...antdProps} />;
};

export default FormComponent;
